module.exports = __webpack_public_path__ + "assets/images/gsRp4igZ.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wopi360-intro-2x.png
// module id = 1116
// module chunks = 0